import { initializeNativeDateTime } from "./lib/dom.js"

initializeNativeDateTime("#datetime, #meeting1from, #meeting1to, #meeting2from, #meeting2to")
